import React from 'react'

import "./Home.css"

import Vid from "../assets/video/V2.mp4"
import { IoMail } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'

import CustomSolution from '../assets/image/Custom Solution.png'
import EfficientManufacturing from '../assets/image/Efficient Manufacturing.png'
import QualityControl from '../assets/image/Quality Control.png'
import CardItems from '../widgets/Card/CardItems'

import service1 from '../assets/image/1.jpg'
import service2 from '../assets/image/2.jpg'
import service3 from '../assets/image/3.jpg'
import service4 from '../assets/image/4.jpg'
import service5 from '../assets/image/5.jpg'
import service6 from '../assets/image/6.jpg'

import Product1 from '../assets/image/Wedges.png'
import Product2 from '../assets/image/tile leveling clip.png'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import SliderItem from '../widgets/Slide/SliderItem'


const Home = () => {

// eslint-disable-next-line
    const [t,i18n]=useTranslation("global")

    const focusDescription = t("about.focusDescription",{returnObjects:true})
    const imageAboutData = [QualityControl,EfficientManufacturing,CustomSolution]

    const serviceList = t("service.serviceList",{returnObjects:true})
    const imageServiceData = [service1,service2,service3,service4,service5,service6]

    const productList = t("product.productsList",{returnObjects:true})
    const imageProductData = [Product1,Product2]

    
    

  return (
    <div className='homeContainer'>
        <section className="hero" id='Hero'>
            <video src={Vid} autoPlay loop muted />
            <div className="bannerContainer">
                <h1>{t("hero.title")}</h1>
                <p>{t("hero.description")}</p>
            <div className="hero__btn">
               <a href={`mailto:${t("footer.email")}`}>
                    <button className='ContactBtn'>
                        <IoMail /> {t("hero.ContactBtn")}
                    </button>
                </a>
            </div>
            </div>
            
        </section>

        <section className="about" id="About">
            <div className="aboutContainer">
                <h1> {t("about.title")} </h1>
                <div className="description">
                    <h2>
                        {t("about.companyName")}
                    </h2>
                    <p>
                        {t("about.companyDescription")}
                    </p>
                </div>

                <div className="card">
                    {
                        focusDescription.map(({ title, description }, index) => (
                            <CardItems
                                key={index}
                                image={imageAboutData[index]}
                                title={title}
                                description={description}
                                reverse={index % 2 !== 0}
                            />
                        ))
                    }
                </div>


            </div>
        </section>

        <section className="service" id="Service">
            <div className="serviceContainer">
                 <h1>
                    {t("service.title")}
                 </h1>
                 <div className="serviceCardsContainer">

                    {
                        serviceList.map(({ title, description }, index) => (
                            <CardItems
                                key={index}
                                image={imageServiceData[index]}
                                title={title}
                                description={description}
                                reverse={index % 2 !== 0}
                            />
                        ))
                    }

                 </div>
            </div>
        </section>

        <section className="product" id="Products">
            <div className="productContainer">
                 <h1>
                    {t("product.title")}
                 </h1>
                 <div className="productCardsContainer">

                    <Swiper
                        spaceBetween={30}
                        slidesPerView={1}
                        autoplay={{
                          delay: 4000,
                          disableOnInteraction: false,
                        }}
                        speed={2000}
                        pagination={{ clickable: true }}
                        modules={[Pagination, Autoplay]}
                        className="productSlidContainer"
                    >
                        {productList.map(({ title, description }, index) => (
                          <SwiperSlide className="slidItem" key={index}>
                            <SliderItem
                              image={imageProductData[index]}
                              title={title}
                              description={description}
                            />
                          </SwiperSlide>
                        ))}
                    </Swiper>

                 </div>
            </div>
        </section>

    </div>
  )
}

export default Home